import { on } from '@disy/lib/event-util';

const KEYBOARD_CLICK_CLASS = 'keyboard-click';
export const KEYBOARD_CLICK_CLASS_SPACE = 'keyboard-click-space';
const KEYBOARD_CLICK_CLASS_ENTER = 'keyboard-click-enter';

export function setupKeyboardClick() {
  on(document, 'keydown', forwardToClick('Enter'), {
    delegate: `.${KEYBOARD_CLICK_CLASS},.${KEYBOARD_CLICK_CLASS_ENTER}`,
    capture: true,
  });
  on(document, 'keyup', forwardToClick(' '), {
    delegate: `.${KEYBOARD_CLICK_CLASS},.${KEYBOARD_CLICK_CLASS_SPACE}`,
    capture: true,
  });

  function forwardToClick(key: string) {
    return (event: KeyboardEvent) => {
      if (event.key === key) {
        event.stopPropagation();
        event.preventDefault();
        (event.target as HTMLElement).click();
      }
    };
  }
}
